import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckoutFlowService } from 'src/app/knbr-dual-checkout/checkout-flow-service';
import { KnBrCheckoutService } from 'src/app/services/kn-br-checkout-service';
import { FormErrorsComponent } from '@spartacus/storefront';
import { NgClass } from '@angular/common';

@Component({
    selector: 'knbr-cwt-checkout-instructions',
    templateUrl: './cwt-checkout-instructions.component.html',
    imports: [
        ReactiveFormsModule,
        FormErrorsComponent,
        NgClass,
    ],
})
export class CwtCheckoutInstructionsComponent {
  protected subscription = new Subscription();
  deliveryInstructionsForm: FormGroup;
  additionalContactForm: FormGroup;
  showAdditionaForm = false;
  showHideDeliveryAppt: boolean;
  phRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;
  sectionCompleted = false;
  sectionActive = true;
  deliveryMode: string;
  selectedDate = '';
  currentUrl = '';
  formData:any = '';

  deliveryLocation = [
    { label: "Business", value: "BUSINESS" },
    { label: "Residential", value: "RESIDENTIAL" },
    { label: "Job Site", value: "JOBSITE" },
  ];
  yesNoOptions = [
    { label: "Yes", value: "YES" },
    { label: "No", value: "NO" }
  ];

  timeSlots:any = []
disabledDatesNew=[];
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    protected activatedRoute: ActivatedRoute,
    private checkoutService: KnBrCheckoutService,
    protected checkoutFlowService: CheckoutFlowService,
    protected cdr: ChangeDetectorRef,
  ) {
    this.checkoutFlowService.mode$.subscribe((mode) => {
      if (mode) {
        this.deliveryMode = mode;
      }
    });
    this.checkoutFlowService.selectedDate$.subscribe((res) => { this.selectedDate = res })
    this.currentUrl = this.router.url;
    if (this.currentUrl.includes('/checkout')) {
      this.checkoutService.isCheckout$.next(true);
    }
  }

  ngOnInit() {
    this.subscription.add(
      this.checkoutFlowService.getCart().subscribe((res) => {
        this.formData = res?.deliveryContactInfo;
      })
    );
    this.initForm(this.formData);
    this.subscription.add(
      this.deliveryInstructionsForm?.get('deliveryAppointment')?.valueChanges.subscribe(value => {
        this.onChange(value);
      })
    );
    this.subscription.add(
      this.checkoutService.getHolidaysList().subscribe((res: any) => {
        if (res) {
          this.disabledDatesNew = this.convertDisabledDatesToTime(res);
          this.cdr.detectChanges()
          }
  })
  );
    this.subscription.add(
    this.checkoutService.getDeliveryTimeSlotsInInstructions()
    .subscribe((timeslotsResp: any) => {

      const currentHourEST = new Date().getHours();
      const sortedSlots = this.sortTimeslotsByKey(timeslotsResp);
      console.log('currentHourEST', currentHourEST);
      const nextDateForTimeSlot =this.getNextAvailableBusinessDateForTimeSlot();
      const formatted = nextDateForTimeSlot.toLocaleDateString("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric"
});
      // After 2 PM → show only 12 PM to 5 PM slots
      if ((this.selectedDate == formatted) && (currentHourEST >= 14)) {
        this.timeSlots = sortedSlots.slice(5);
      } else {
        this.timeSlots = sortedSlots;
      }
      this.cdr.detectChanges();
    })
);
  }
  convertDisabledDatesToTime(dates: string[]): number[] {
  return dates.map(d => {
    // Convert string to Date
    const date = new Date(d);

    // Normalize to start of day (local time)
    date.setHours(0, 0, 0, 0);

    return date.getTime();
  });
}
isHoliday(date: Date): boolean {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return this.disabledDatesNew.includes(d.getTime());
}
getNextAvailableBusinessDateForTimeSlot(): Date {

  // Start from today at midnight
  let candidate = new Date()
  candidate.setHours(0, 0, 0, 0);
  // calendar start date always starts from next day for delivery for next business day
  candidate.setDate(candidate.getDate() + 1);

  // Keep moving forward until a valid business day is found
  while (
    candidate.getDay() === 0 ||               // Sunday
    candidate.getDay() === 6 ||               // Saturday
    this.isHoliday(candidate)                 // Holiday
  ) {
    candidate.setDate(candidate.getDate() + 1);
  }
  
  return candidate;
}


 sortTimeslotsByKey(timeslotsOptions) {
   if (!timeslotsOptions || timeslotsOptions.length === 0) {
    return []; 
  }
  return [...timeslotsOptions].sort((a, b) => {
    const numA = parseInt(a.key.replace('TIMESLOT', ''), 10);
    const numB = parseInt(b.key.replace('TIMESLOT', ''), 10);
    return numA - numB;
  });
}

  isChecked(value) {
    if (value === this.formData?.deliveryInstructions?.deliveryLocation) {
      return true;
    }
    return false;
  }

  initForm(formData?) {
    if (formData?.additionalFirstName || formData?.additionalLastName || formData?.additionalMobileNumber) {
      this.showAdditionaForm = true;
    };

    let deliveryHoursText = formData?.deliveryInstructions?.deliveryHoursText || '';
  let deliveryHoursPeriod = '';

  if (deliveryHoursText) {
    const parts = deliveryHoursText.trim().split(' ');
    const lastPart = parts[parts.length - 1].toUpperCase();
    if (lastPart === 'AM' || lastPart === 'PM') {
      deliveryHoursPeriod = lastPart;
      deliveryHoursText = parts.slice(0, -1).join(' ');
    }
  }

    this.deliveryInstructionsForm = this.formBuilder.group({
      deliveryMode: [this.deliveryMode],
      scheduledDeliveryDate: [this.selectedDate],
      firstName: [formData?.firstName || '', Validators.required],
      lastName: [formData?.lastName || '', Validators.required],
      mobileNumber: [this.formatPhone(formData?.mobileNumber) || '', [Validators.required, Validators.pattern(this.phRegex)]],
      additionalFirstName: [{ value: formData?.additionalFirstName || '', disabled: !formData?.additionalFirstName }],
      additionalLastName: [{ value: formData?.additionalLastName || '', disabled: !formData?.additionalLastName }],
      additionalMobileNumber: [{ value: formData?.additionalMobileNumber || '', disabled: !formData?.additionalMobileNumber }, Validators.pattern(this.phRegex)],
      deliveryLocation: [formData?.deliveryInstructions?.deliveryLocation || '', Validators.required],
      liftGate: [formData?.deliveryInstructions?.liftGate || '', Validators.required],
      palletJack: [formData?.deliveryInstructions?.palletJack || '', Validators.required],
      callAhead: [formData?.deliveryInstructions?.callAhead || '', Validators.required],
      driverAssistance: [formData?.deliveryInstructions?.driverAssistance || '', Validators.required],
      specialHandlingText: [formData?.deliveryInstructions?.specialHandlingText || ''],
      insideDelivery: [formData?.deliveryInstructions?.insideDelivery || '', Validators.required],
      deliveryAppointment: [formData?.deliveryInstructions?.deliveryAppointment || '', Validators.required],
      appointmentTimeSlot: [{ value: formData?.deliveryInstructions?.appointmentTimeSlot || '', disabled: true }, Validators.required],
      deliveryHoursText: [deliveryHoursText, Validators.required],
      deliveryHoursPeriod: [deliveryHoursPeriod || null, Validators.required],
  });
    const fieldsToTouch = ['firstName', 'lastName', 'mobileNumber'];

  fieldsToTouch.forEach((field) => {
    this.deliveryInstructionsForm.get(field)?.markAsTouched();
  });
     this.onChange(formData?.deliveryInstructions?.deliveryAppointment);
  }
  formatPhone(raw: string): string {
    const digits = raw?.replace(/\D/g, "").slice(0, 10);
    if (digits?.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return raw;
  }

  onChange(value) {
    if (value === 'yes' || value === 'YES') {
      this.showHideDeliveryAppt = true;
      this.deliveryInstructionsForm.get('appointmentTimeSlot')?.enable();
      this.deliveryInstructionsForm.get('deliveryHoursText').disable();
      this.deliveryInstructionsForm.get('deliveryHoursPeriod')?.disable();
      this.deliveryInstructionsForm.get('deliveryHoursText').reset();
      this.deliveryInstructionsForm.get('deliveryHoursPeriod')?.reset();
    } else {
      this.showHideDeliveryAppt = false;
      this.deliveryInstructionsForm.get('deliveryHoursText')?.enable();
      this.deliveryInstructionsForm.get('deliveryHoursPeriod')?.enable();
      this.deliveryInstructionsForm.get('appointmentTimeSlot').disable();
      this.deliveryInstructionsForm.get('appointmentTimeSlot').reset();
    }
  }


  isInvalid(controlName: string): boolean {
    const control = this.deliveryInstructionsForm.get(controlName);
    return !!(control && control.invalid && control.touched);
  }

  enableDisableFormFields(isEnabled) {
    this.showAdditionaForm = isEnabled;
    const controls = ['additionalFirstName', 'additionalLastName', 'additionalMobileNumber'];

    controls.forEach(controlName => {
      const control = this.deliveryInstructionsForm.get(controlName);
      if (control) {
        isEnabled ? control.enable() : (control.disable && control.reset());
      }
    });
  }

  formatPhoneNumber(ctrl) {
    const phoneCtrl = this.deliveryInstructionsForm.get(ctrl);
    if (phoneCtrl) {
      let digits = phoneCtrl.value.replace(/\D/g, "");
      if (digits.length > 10) digits = digits.slice(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      }
      phoneCtrl.setValue(formatted, { emitEvent: false });
    }
  }

  onSubmit() {
    const { deliveryHoursText, deliveryHoursPeriod, deliveryLocation, liftGate, driverAssistance,palletJack,callAhead, specialHandlingText, insideDelivery, deliveryAppointment, appointmentTimeSlot, ...modifiedObject } = this.deliveryInstructionsForm.value;
    const deliveryInstructions = { deliveryLocation, liftGate,palletJack,callAhead, driverAssistance, specialHandlingText, insideDelivery, deliveryAppointment, appointmentTimeSlot };

    if (!this.showHideDeliveryAppt) {
      const combinedDeliveryHours = `${deliveryHoursText} ${deliveryHoursPeriod}`;
      Object.assign(deliveryInstructions, { deliveryHoursText: combinedDeliveryHours });
    };

    Object.assign(modifiedObject, { deliveryInstructions: deliveryInstructions});

    this.sectionActive = false;
    const routeValue = this.getRouteInfo();  
    modifiedObject.scheduledDeliveryDate = this.getStandardDateFromString(modifiedObject.scheduledDeliveryDate)
    this.checkoutService.saveDeliveryInstructions({ deliveryContactInfo: modifiedObject }).subscribe(resp => {
      this.sectionCompleted = true;
      this.checkoutFlowService.markCompleted(this.deliveryMode, routeValue);
      this.router.navigateByUrl('checkout/payment');
    });
  }
getStandardDateFromString(dateString: string): string {
  if (!dateString) return '';

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return ''; // invalid date safety

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}T00:00:00`;
}
  getRouteInfo() {
    const segments = this.router.url.split("/").filter(Boolean);
    const lastTwo = segments.slice(-2).join("/");
    return lastTwo;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}

